import { httpService } from '../helper';
import { constants } from '../constants';

export const getProvisionalOffer = async () => httpService().get(constants.API.PROVISIONAL_LETTER);
export const updateProvisionLetter = async (payload) => httpService().put(constants.API.PROVISIONAL_LETTER, payload);
